<template>
    <div class="col-12 mt-2" id="generate_dispute_step">
        <dispute-letter-component></dispute-letter-component>
    </div>
</template>
<script>
import { useUserStore } from '../../stores/UserStore.js'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import DisputeLetterComponent from './DisputeLetterComponent'
export default{
    components:{
        DisputeLetterComponent
    },
    setup() {
        return{
            userStore: useUserStore(),
            localizationStore: useLocalizationStore()
        }
    },
    created(){
        this.userStore.fetchUser();
        this.userStore.fetchCheckValidUserDispute();
    }
}
</script>
